import { render } from "./ArticleRow.vue?vue&type=template&id=cdb713e2&scoped=true"
import script from "./ArticleRow.vue?vue&type=script&lang=js"
export * from "./ArticleRow.vue?vue&type=script&lang=js"

import "./ArticleRow.vue?vue&type=style&index=0&id=cdb713e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdb713e2"]])

export default __exports__